import React ,{useState}  from 'react';
import {
    Form, Button, Select, Row, Modal,Input
} from 'antd';

import { Field, reduxForm } from 'redux-form';
import { connect, useSelector } from 'react-redux';
import { required, textArea,FieldSelectNormalEditar } from '../../app/inputs/InputField';
import { ColFlexColumn, ImageHoverAction } from '../style';


const Option = Select.Option;

let RevisarOrden = props => {
   const [visible, showModal]=useState(false)
   const [image, getImage]=useState(null)
   let usuario = useSelector(state => state.reducerUsuario.usuario)

   const showModalImage=(image)=>{
        showModal(true)
        getImage(image)
   }


   const filtersUser = (usuario) => {
    if (usuario.user_permissions && usuario.user_permissions.length > 0) {
        let permisoUsuario = usuario.user_permissions[0].codename
        switch (permisoUsuario) {
            case "surtidor":
                return {
                  status_orden: [
                    {
                        value: 'a',
                        label: 'APROBADA'
                    },
                    // {
                    //     value: 'v',
                    //     label: 'VALIDADA'
                    // },
                    {
                        value: 's',
                        label: 'SURTIDA'
                    },
                    {
                        value: 'i',
                        label: 'SURTIDA INCOMPLETO'
                    }
                ],
                    tipo_orden: [
                        {
                            value: 'CONTADO',
                            label: 'CONTADO'
                        },
                        {
                            value: 'CREDITO',
                            label: 'CREDITO'
                        },
                        {
                            value: 'ANTICIPADO',
                            label: 'ANTICIPADO'
                        }                
                    ]
                }
            case "validador":
                return {
                    status_orden: [
                        {
                            value: 'a',
                            label: 'APROBAR'
                        },
                        {
                          value: 'c',
                          label: 'CANCELAR'
                      },
                        {
                            value: 'v',
                            label: 'VALIDAR'
                        }

                    ],
                    tipo_orden: [
                        {
                            value: 'ANTICIPADO',
                            label: 'ANTICIPADO'
                        },
                    ]
                }
            case "cajero":
                console.log("hola cajero")
                break;
            default:
                break;
        }
    }
    return {
        status_orden: [
            {
                value: 'g',
                label: 'GENERADA'
            },
            {
                value: 'a',
                label: 'APROBADA'
            },
            {
                value: 'c',
                label: 'CANCELADA'
            },
            {
                value: 'v',
                label: 'VALIDADA'
            },
            {
                value: 's',
                label: 'SURTIDA'
            },
            {
                value: 'i',
                label: 'SURTIDA INCOMPLETO'
            },
        ],
        tipo_orden: [
            {
                value: 'CONTADO',
                label: 'CONTADO'
            },
            {
                value: 'ANTICIPADO',
                label: 'ANTICIPADO'
            },
            {
                value: 'CREDITO',
                label: 'CREDITO'
            }
        ]

    }
}

   const InputNumber = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <Input
            placeholder={ph}
            onChange={input.onChange}
            value={input.value}
            size={"default"}
            onBlur={input.onBlur}
        />
    </Form.Item>
)

    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="status" component={FieldSelectNormalEditar} ph="Status" validate={[required]}>
          {/* <Option value={"g"} >Generada</Option>
          <Option value={"a"} >Aprobada</Option>
          <Option value={"c"} >Cancelada</Option>
          <Option value={"v"} >Validar</Option>
          <Option value={"s"} >Surtida</Option>
          <Option value={"i"} >Surtida Incompleto</Option> */}
          {filtersUser(usuario).status_orden.map((item, index) => {
            return <Option key={index} value={item.value}>{item.label}</Option>
          })}

        </Field>
        <Field name="tipoorden" component={FieldSelectNormalEditar} ph="Tipo de Orden" validate={[required]}>
          <Option value={"CREDITO"} >CREDITO</Option>
          <Option value={"CONTADO"} >CONTADO</Option>
          <Option value={"ANTICIPADO"} >ANTICIPADO</Option>
        </Field>
        <Field name="diasdecredito" component={FieldSelectNormalEditar} ph="Dias de Credito" validate={[required]} >
              <Option value={1} >{1}</Option>
              <Option value={2} >{2}</Option>
              <Option value={3} >{3}</Option>
              <Option value={4} >{4}</Option>
              <Option value={5} >{5}</Option>
              <Option value={10} >{10}</Option>
              <Option value={15} >{15}</Option>
              <Option value={20} >{20}</Option>
              <Option value={30} >{30}</Option>
        </Field>
        <Field name="comentario" component={textArea} ph="Comentario" validate={[required]} />
        <Field name="cargos" component={InputNumber} ph="Cargos Adicionales" validate={[required]} />

        <Form.Item>
          <Row type="flex" justify="space-around" align="middle">
            {
              props.initialValues?
              props.initialValues.archivos && props.initialValues.archivos.length > 0 ?
                <ColFlexColumn xl={12} lg={12} md={12} sm={24} xs={24}>
                  <ImageHoverAction>
                    <img src={props.initialValues.archivos[0].impresion} alt="archivo 1" />
                    <div className="middle">
                      <Button onClick={() => showModalImage(props.initialValues.archivos[0].impresion)} type="primary" shape="circle" icon="eye" />
                    </div>
                  </ImageHoverAction>
                </ColFlexColumn> : null

              :null
            }

            {
              props.initialValues ?
              props.initialValues.archivos_dos && props.initialValues.archivos_dos.length > 0 ?
              <ColFlexColumn xl={12} lg={12} md={12} sm={24} xs={24}>
                <ImageHoverAction>
                  <img src={props.initialValues.archivos_dos[0].impresiondos} alt="archivo 1" />
                  <div className="middle">
                    <Button onClick={() => showModalImage(props.initialValues.archivos_dos[0].impresiondos)} type="primary" shape="circle" icon="eye" />
                  </div>
                </ImageHoverAction>
              </ColFlexColumn> : null

                : null
            }


            <Modal
              visible={visible}
              onOk={() => showModal(false)}
              onCancel={() => showModal(false)}
              footer={false}
            >
              <Row>
                <ColFlexColumn xl={24} lg={24} md={24} sm={24} xs={24}>
                 <img src={image} alt="archivo 1" style={{width:"100%"}} />
                </ColFlexColumn>
              </Row>
             
            </Modal>
          </Row>
            
        </Form.Item>
        <Form.Item>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
   
  }

  RevisarOrden = reduxForm({
    form: 'RevisarOrden',
    forceUnregisterOnUnmount:true,
    destroyOnUnmount:true,
    enableReinitialize:true
  })(RevisarOrden)
  RevisarOrden = connect(
    state => ({
      initialValues: state.reducerOrdenes.orden// pull initial values from account reducer
    })
  )(RevisarOrden)

  export default RevisarOrden

